module.exports = __webpack_public_path__ + "static/media/la-piquera.1cc2ceaf.svg";